export const formatCount = (count, itemType) => `${count} ${itemType}`;
